import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import emaarherosection from '../../Images/Emaar/emaarherosection.png';
import emaarherosectionformobile from '../../Images/Emaar/emaarherosectionformobile.jpg';

// ── API ────────────────────────────────────────────────────────
const API_URL =
  "https://homewalkers.realatixcrm.com/api/v1/users/create-with-params" +
  "?addedby=68da45a5b37ddfab3b73bd8b" +
  "&stage=68d110bbad5a0732ad44e5cf" +
  "&Channal=6a48bfa6a4cf5854ad69d511" +
  "&project=6a424455cbc3b90bfa64cd4b" +
  "&salesdata=68da75b5b37ddfab3b7463f5" +
  "&Communicationway=69159308820816f4ad71c3bf" +
  "&campaignid=68e3a33dbd4758877fb945a1" +
  "&includePhone2=false" +
  "&includeWhatsapp=false" +
  "&includeJobDesc=false" +
  "&includeQuestion1=true" +
  "&question1_text=%D8%A7%D9%84%D8%BA%D8%B1%D8%B6++%D9%85%D9%86+%D8%A7%D9%84%D8%B4%D8%B1%D8%A7%D8%A1+%D8%9F" +
  "&includeQuestion2=true" +
  "&question2_text=%D8%B9%D8%AF%D8%AF+%D8%A7%D9%84%D8%BA%D8%B1%D9%81+%D8%9F" +
  "&includeQuestion3=false" +
  "&includeQuestion4=false" +
  "&includeQuestion5=false";

// ── خيارات الفورم ──────────────────────────────────────────────
const purposeOptions = ['السكن', 'الاستثمار', 'سكن واستثمار'];
const roomOptions    = ['استوديو', '1 غرفة', '2 غرفة', '3 غرفة'];

// ── أكواد الدول (iso2 + dial code) ──────────────────────────────
const countryCodes = [
  { iso: 'ae', name: 'الإمارات',        dial: '+971' },
  { iso: 'sa', name: 'السعودية',        dial: '+966' },
  { iso: 'eg', name: 'مصر',             dial: '+20'  },
  { iso: 'kw', name: 'الكويت',          dial: '+965' },
  { iso: 'qa', name: 'قطر',             dial: '+974' },
  { iso: 'bh', name: 'البحرين',         dial: '+973' },
  { iso: 'om', name: 'عُمان',           dial: '+968' },
  { iso: 'jo', name: 'الأردن',          dial: '+962' },
  { iso: 'lb', name: 'لبنان',           dial: '+961' },
  { iso: 'iq', name: 'العراق',          dial: '+964' },
  { iso: 'sy', name: 'سوريا',           dial: '+963' },
  { iso: 'ye', name: 'اليمن',           dial: '+967' },
  { iso: 'ps', name: 'فلسطين',          dial: '+970' },
  { iso: 'ma', name: 'المغرب',          dial: '+212' },
  { iso: 'dz', name: 'الجزائر',         dial: '+213' },
  { iso: 'tn', name: 'تونس',            dial: '+216' },
  { iso: 'ly', name: 'ليبيا',           dial: '+218' },
  { iso: 'sd', name: 'السودان',         dial: '+249' },
  { iso: 'so', name: 'الصومال',         dial: '+252' },
  { iso: 'dj', name: 'جيبوتي',          dial: '+253' },
  { iso: 'km', name: 'جزر القمر',       dial: '+269' },
  { iso: 'mr', name: 'موريتانيا',       dial: '+222' },
  { iso: 'tr', name: 'تركيا',           dial: '+90'  },
  { iso: 'ir', name: 'إيران',           dial: '+98'  },
  { iso: 'pk', name: 'باكستان',         dial: '+92'  },
  { iso: 'in', name: 'الهند',           dial: '+91'  },
  { iso: 'bd', name: 'بنغلاديش',        dial: '+880' },
  { iso: 'lk', name: 'سريلانكا',        dial: '+94'  },
  { iso: 'np', name: 'نيبال',           dial: '+977' },
  { iso: 'ph', name: 'الفلبين',         dial: '+63'  },
  { iso: 'id', name: 'إندونيسيا',       dial: '+62'  },
  { iso: 'my', name: 'ماليزيا',         dial: '+60'  },
  { iso: 'cn', name: 'الصين',           dial: '+86'  },
  { iso: 'us', name: 'الولايات المتحدة', dial: '+1'   },
  { iso: 'gb', name: 'المملكة المتحدة', dial: '+44'  },
  { iso: 'fr', name: 'فرنسا',           dial: '+33'  },
  { iso: 'de', name: 'ألمانيا',         dial: '+49'  },
  { iso: 'it', name: 'إيطاليا',         dial: '+39'  },
  { iso: 'es', name: 'إسبانيا',         dial: '+34'  },
  { iso: 'ru', name: 'روسيا',           dial: '+7'   },
  { iso: 'ca', name: 'كندا',            dial: '+1'   },
  { iso: 'au', name: 'أستراليا',        dial: '+61'  },
  { iso: 'za', name: 'جنوب أفريقيا',    dial: '+27'  },
  { iso: 'ng', name: 'نيجيريا',         dial: '+234' },
  { iso: 'ke', name: 'كينيا',           dial: '+254' },
  { iso: 'et', name: 'إثيوبيا',         dial: '+251' },
  { iso: 'br', name: 'البرازيل',        dial: '+55'  },
  { iso: 'jp', name: 'اليابان',         dial: '+81'  },
  { iso: 'kr', name: 'كوريا الجنوبية',  dial: '+82'  },
];

// ── Field style (نفس استايل EmaarContactForm) ───────────────────
const inputStyle = {
  width:        '100%',
  padding:      '13px 16px',
  border:       '1.5px solid #e0d8cc',
  borderRadius: '10px',
  fontSize:     '14px',
  fontFamily:   "'Cairo', sans-serif",
  color:        '#1a1a1a',
  background:   '#fff',
  outline:      'none',
  boxSizing:    'border-box',
  direction:    'rtl',
  transition:   'border-color 0.2s ease, box-shadow 0.2s ease',
};

const labelStyle = {
  fontSize:     '13px',
  fontWeight:   '600',
  color:        '#444',
  display:      'block',
  marginBottom: '7px',
  direction:    'rtl',
};

export const EmaarHeroSection = () => {
  const [showModal, setShowModal] = useState(false);
  const formRef = useRef(null);

  // Refs للعناصر
  const badgeRef    = useRef(null);
  const headingRef  = useRef(null);
  const subtext1Ref = useRef(null);
  const subtext2Ref = useRef(null);
  const btnRef      = useRef(null);
  const quickRef    = useRef(null);
  const scrollRef   = useRef(null);

  // ── Form state (نفس منطق EmaarContactForm) ──────────────────
  const [formData, setFormData] = useState({
    name:              '',
    phone:             '',
    email:             '',
    question1_answer:  'السكن',
    question2_answer:  '',
  });
  const [countryIso, setCountryIso] = useState('ae');
  const [loading, setLoading] = useState(false);
  const [alert,   setAlert]   = useState({ show: false, message: '', ok: false });

  const selectedCountry = countryCodes.find((c) => c.iso === countryIso) || countryCodes[0];

  // ── Quick phone capture (Hero CTA) ───────────────────────────
  const [quickPhone, setQuickPhone]           = useState('');
  const [quickCountryIso, setQuickCountryIso] = useState('ae');
  const [quickStatus, setQuickStatus]         = useState(null); // null | 'sending' | 'sent' | 'error' | 'invalid'
  const [quickDropdownOpen, setQuickDropdownOpen] = useState(false);
  const [quickSearch, setQuickSearch] = useState('');
  const quickWrapperRef = useRef(null);

  const quickSelectedCountry = countryCodes.find((c) => c.iso === quickCountryIso) || countryCodes[0];

  const quickFilteredCountries = countryCodes.filter((c) => {
    const q = quickSearch.trim().toLowerCase();
    if (!q) return true;
    return (
      c.dial.replace('+', '').includes(q.replace('+', '')) ||
      c.name.toLowerCase().includes(quickSearch.trim().toLowerCase()) ||
      c.name.includes(quickSearch.trim())
    );
  });

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (quickWrapperRef.current && !quickWrapperRef.current.contains(e.target)) {
        setQuickDropdownOpen(false);
        setQuickSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleQuickSend = async () => {
    const cleanPhone = quickPhone.replace(/\D/g, '');
    if (!cleanPhone || cleanPhone.length < 6) {
      setQuickStatus('invalid');
      setTimeout(() => setQuickStatus(null), 2500);
      return;
    }

    const fullPhone = `${quickSelectedCountry.dial}${cleanPhone}`;

    try {
      setQuickStatus('sending');
      const res = await fetch(API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:  'no name',
          email: '',
          phone: fullPhone,
        }),
      });

      if (!res.ok) throw new Error(`${res.status}`);

      setQuickStatus('sent');
      setQuickPhone('');
      setTimeout(() => setQuickStatus(null), 2500);
    } catch (err) {
      setQuickStatus('error');
      setTimeout(() => setQuickStatus(null), 2500);
    }
  };

  const handleQuickKeyDown = (e) => {
    if (e.key === 'Enter') handleQuickSend();
  };

  useEffect(() => {
    const tl = gsap.timeline({ delay: 0.1 });

    gsap.set(
      [badgeRef.current, headingRef.current, subtext1Ref.current, subtext2Ref.current, btnRef.current, quickRef.current, scrollRef.current],
      { opacity: 0, y: 30 }
    );

    tl.to(badgeRef.current,    { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' })
      .to(headingRef.current,  { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, '-=0.4')
      .to(subtext1Ref.current, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, '-=0.4')
      .to(subtext2Ref.current, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, '-=0.4')
      .to(btnRef.current,      { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, '-=0.4')
      .to(quickRef.current,    { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, '-=0.4')
      .to(scrollRef.current,   { opacity: 0.7, y: 0, duration: 0.8, ease: 'power3.out' }, '-=0.2');

    return () => tl.kill();
  }, []);

  // ── Alert auto-hide ────────────────────────────────────────
  useEffect(() => {
    if (!alert.show) return;
    const t = setTimeout(() => setAlert((p) => ({ ...p, show: false })), 5000);
    return () => clearTimeout(t);
  }, [alert.show]);

  // ── Handlers ───────────────────────────────────────────────
  const handleChange = (field) => (e) =>
    setFormData((p) => ({ ...p, [field]: e.target.value }));

  const handleFocus = (e) => {
    e.target.style.borderColor = '#c8a04a';
    e.target.style.boxShadow   = '0 0 0 3px rgba(200,160,74,0.12)';
  };
  const handleBlur = (e) => {
    e.target.style.borderColor = '#e0d8cc';
    e.target.style.boxShadow   = 'none';
  };

  // ── Submit ─────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    const phone = formData.phone.trim();
    if (!phone || phone.replace(/\D/g, '').length < 6)
      return setAlert({ show: true, message: 'يرجى إدخال رقم هاتف صحيح', ok: false });

    const fullPhone = `${selectedCountry.dial}${phone.replace(/\D/g, '')}`;

    setLoading(true);
    setAlert({ show: false, message: '', ok: false });

    try {
      const res = await fetch(API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:             formData.name.trim() || 'no name',
          email:            formData.email.trim().toLowerCase() || '',
          phone:            fullPhone,
          question1_answer: formData.question1_answer,
          question2_answer: formData.question2_answer,
        }),
      });

      if (!res.ok) throw new Error(`${res.status}`);

      setAlert({ show: true, message: 'تم الإرسال بنجاح ✅', ok: true });
      setFormData({ name: '', phone: '', email: '', question1_answer: 'السكن', question2_answer: '' });

    } catch (err) {
      const status = err.message;
      setAlert({
        show: true,
        ok:   false,
        message:
          status.includes('409') ? 'رقم الهاتف مسجّل مسبقاً'
        : status.includes('400') ? 'بيانات غير صحيحة، يرجى المراجعة'
        : 'حدث خطأ، يرجى المحاولة مجدداً',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{
        position:   'relative',
        width:      '100%',
        height:     '100vh',
        overflow:   'hidden',
        fontFamily: "'Cairo', sans-serif",
        direction:  'rtl',
      }}>

        {/* Background Image - Responsive */}
        <picture>
          <source srcSet={emaarherosectionformobile} media="(max-width: 768px)" />
          <img
            src={emaarherosection}
            alt="Emaar Fields Dubai South"
            style={{
              position:   'absolute',
              inset:      0,
              width:      '100%',
              height:     '100%',
              objectFit:  'cover',
              objectPosition: 'center',
            }}
          />
        </picture>

        {/* Dark Overlay */}
        <div style={{
          position:   'absolute',
          inset:      0,
          background: 'radial-gradient(circle at center, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.25) 100%)',
        }} />

        {/* Content - الآن في النص */}
        <div style={{
          position:       'relative',
          zIndex:         2,
          height:         '100%',
          display:        'flex',
          flexDirection:  'column',
          justifyContent: 'center',
          alignItems:     'center',
          padding:        '0 2vw',
          textAlign:      'center',
        }}>

          {/* Badge */}
          <div
            ref={badgeRef}
            // style={{
            //   opacity:         0,
            //   background:      'rgba(255,255,255,0.15)',
            //   backdropFilter:  'blur(8px)',
            //   border:          '1px solid rgba(255,255,255,0.3)',
            //   color:           '#fff',
            //   fontSize:        '13px',
            //   fontWeight:      '600',
            //   letterSpacing:   '2px',
            //   padding:         '8px 20px',
            //   borderRadius:    '30px',
            //   // marginBottom:    '24px',
            //   textTransform:   'uppercase',
            // }}
          >
            {/* اعمار للتطوير العقاري */}
            {/* اعمار فيلد · دبي الجنوب */}
          </div>

          {/* Heading */}
          <h1
            ref={headingRef}
            style={{
              opacity:    0,
              color:      '#fff',
              fontSize:   'clamp(46px, 6vw, 72px)',
              fontWeight: '900',
              lineHeight: '1.2',
              margin:     '0 0 1px 0',
              textShadow: '0 2px 20px rgba(0,0,0,0.4)',
            }}
          >
            شقق اعمار فيلد<br />في دبي الجنوب
          </h1>

          {/* Subtext 1 */}
          <p
            ref={subtext1Ref}
            style={{
              opacity:    0,
              color:      'rgba(255,255,255,0.9)',
              fontSize:   'clamp(36px, 4.2vw, 42px)',
              fontWeight: '400',
              margin:     '0 0 10px 0',
              fontFamily: "'Cairo', sans-serif",
              
            }}
          >
            بدفعة أولى <span style={{ fontSize:'40px',color: '#f0c060', fontWeight: '900' }}>20%</span> فقط
          </p>

          {/* Subtext 2 */}
          <p
            ref={subtext2Ref}
            style={{
              opacity:    0,
              color:      'rgba(255,255,255,0.85)',
              fontSize:   'clamp(40px, 2.8vw, 28px)',
              fontWeight: '400',
              margin:     '0 0 40px 0',
            }}
          >
            تبدأ من <span style={{ color: '#f0c060', fontWeight: '850', fontSize: 'clamp(30px, 3.5vw, 30px)' }}>1,260,000</span> درهم
          </p>

          {/* CTA Button */}
          <button
            ref={btnRef}
            onClick={() => setShowModal(true)}
            style={{
              opacity:      0,
              background:   '#c8a04a',
              color:        '#fff',
              border:       'none',
              borderRadius: '50px',
              padding:      '16px 48px',
              fontSize:     'clamp(15px, 1.8vw, 18px)',
              fontWeight:   '700',
              fontFamily:   "'Cairo', sans-serif",
              cursor:       'pointer',
              letterSpacing: '0.5px',
              boxShadow:    '0 4px 24px rgba(200,160,74,0.45)',
              transition:   'background 0.3s ease, box-shadow 0.3s ease',
            }}
            onMouseEnter={e => {
              e.target.style.background = '#b8903a';
              e.target.style.boxShadow  = '0 6px 32px rgba(200,160,74,0.65)';
            }}
            onMouseLeave={e => {
              e.target.style.background = '#c8a04a';
              e.target.style.boxShadow  = '0 4px 24px rgba(200,160,74,0.45)';
            }}
          >
             تواصل معنا  
          </button>

          {/* Quick Phone Capture */}
          <div
            ref={quickRef}
            style={{ opacity: 0 }}
          >
            <div
              ref={quickWrapperRef}
              style={{
                position: 'relative',
                marginTop: '28px',
                width: '100%',
                maxWidth: '460px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'stretch',
                  direction: 'ltr',
                  background: 'rgba(255,255,255,0.95)',
                  borderRadius: '50px',
                  overflow: 'hidden',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.25)',
                }}
              >
                {/* Country selector */}
                <button
                  type="button"
                  onClick={() => setQuickDropdownOpen((v) => !v)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    border: 'none',
                    background: 'transparent',
                    padding: '0 14px',
                    fontSize: '0.95rem',
                    fontFamily: "'Cairo', sans-serif",
                    color: '#222',
                    cursor: 'pointer',
                    borderInlineEnd: '1px solid #e0e0e0',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <img
                    src={`https://flagcdn.com/w20/${quickSelectedCountry.iso}.png`}
                    alt={quickSelectedCountry.iso}
                    style={{ width: '18px', borderRadius: '2px' }}
                  />
                  <span>{quickSelectedCountry.dial}</span>
                  <span style={{ fontSize: '0.7rem', opacity: 0.6 }}>▾</span>
                </button>

                {/* Phone input */}
                <input
                  type="tel"
                  inputMode="numeric"
                  value={quickPhone}
                  onChange={(e) => setQuickPhone(e.target.value)}
                  onKeyDown={handleQuickKeyDown}
                  placeholder="ادخل رقم الهاتف الخاص بك"
                  dir="rtl"
                  style={{
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    padding: '14px 10px',
                    fontSize: '0.95rem',
                    fontFamily: "'Cairo', sans-serif",
                    color: '#222',
                    minWidth: 0,
                    textAlign: 'right',
                  }}
                />

                {/* Send button */}
                <button
                  type="button"
                  onClick={handleQuickSend}
                  disabled={quickStatus === 'sending'}
                  style={{
                    border: 'none',
                    background: '#c8a04a',
                    color: '#fff',
                    fontWeight: 700,
                    fontFamily: "'Cairo', sans-serif",
                    fontSize: '0.95rem',
                    padding: '0 26px',
                    cursor: quickStatus === 'sending' ? 'not-allowed' : 'pointer',
                  }}
                >
                  إرسال
                </button>
              </div>

              {/* Country dropdown */}
              {quickDropdownOpen && (
                <div
                  style={{
                    position: 'absolute',
                    top: 'calc(100% + 8px)',
                    right: 0,
                    width: '260px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    background: '#fff',
                    borderRadius: '14px',
                    boxShadow: '0 10px 35px rgba(0,0,0,0.3)',
                    zIndex: 20,
                    direction: 'rtl',
                  }}
                >
                  {/* Search box */}
                  <div style={{ padding: '8px', position: 'sticky', top: 0, background: '#fff' }}>
                    <input
                      autoFocus
                      type="text"
                      value={quickSearch}
                      onChange={(e) => setQuickSearch(e.target.value)}
                      placeholder="ابحث بالدولة أو الكود"
                      style={{
                        width: '100%',
                        border: '1px solid #e0d8cc',
                        borderRadius: '8px',
                        padding: '8px 10px',
                        fontSize: '0.85rem',
                        fontFamily: "'Cairo', sans-serif",
                        outline: 'none',
                        boxSizing: 'border-box',
                      }}
                    />
                  </div>

                  <div>
                    {quickFilteredCountries.length === 0 && (
                      <div style={{ padding: '12px', fontSize: '0.85rem', color: '#888', textAlign: 'center' }}>
                        لا توجد نتائج
                      </div>
                    )}
                    {quickFilteredCountries.map((c) => (
                      <div
                        key={c.iso}
                        onClick={() => {
                          setQuickCountryIso(c.iso);
                          setQuickDropdownOpen(false);
                          setQuickSearch('');
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '9px 12px',
                          cursor: 'pointer',
                          fontSize: '0.85rem',
                          fontFamily: "'Cairo', sans-serif",
                          background: c.iso === quickSelectedCountry.iso ? '#fff6e0' : 'transparent',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = '#f5f5f5')}
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background =
                            c.iso === quickSelectedCountry.iso ? '#fff6e0' : 'transparent')
                        }
                      >
                        <img src={`https://flagcdn.com/w20/${c.iso}.png`} alt={c.iso} style={{ width: '18px' }} />
                        <span style={{ flex: 1 }}>{c.name}</span>
                        <span style={{ color: '#888' }}>{c.dial}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Status message */}
              {quickStatus && (
                <div
                  style={{
                    marginTop: '8px',
                    fontSize: '0.8rem',
                    fontFamily: "'Cairo', sans-serif",
                    color:
                      quickStatus === 'sent' ? '#8be08b' :
                      quickStatus === 'error' || quickStatus === 'invalid' ? '#ff8080' : '#e0e0e0',
                  }}
                >
                  {quickStatus === 'sending' && 'جارِ الإرسال...'}
                  {quickStatus === 'sent'    && 'تم الإرسال بنجاح ✅'}
                  {quickStatus === 'error'   && 'حدث خطأ، حاول مرة أخرى'}
                  {quickStatus === 'invalid' && 'من فضلك ادخل رقم الهاتف'}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div
          ref={scrollRef}
          style={{
            position:       'absolute',
            bottom:         '32px',
            left:           '50%',
            transform:      'translateX(-50%)',
            zIndex:         2,
            display:        'flex',
            flexDirection:  'column',
            alignItems:     'center',
            gap:            '8px',
            opacity:        0,
          }}
        >
          <div style={{
            width:        '28px',
            height:       '44px',
            border:       '2px solid rgba(255,255,255,0.6)',
            borderRadius: '14px',
            position:     'relative',
          }}>
            <div style={{
              position:     'absolute',
              top:          '6px',
              left:         '50%',
              transform:    'translateX(-50%)',
              width:        '4px',
              height:       '8px',
              background:   'rgba(255,255,255,0.8)',
              borderRadius: '2px',
              animation:    'scrollDot 1.5s ease-in-out infinite',
            }} />
          </div>
        </div>
      </div>

      {/* Modal Contact Form - بنفس استايل EmaarContactForm */}
      {showModal && (
        <div
          onClick={(e) => e.target === e.currentTarget && setShowModal(false)}
          style={{
            position:       'fixed',
            inset:          0,
            background:     'rgba(0,0,0,0.6)',
            zIndex:         1000,
            display:        'flex',
            alignItems:     'center',
            justifyContent: 'center',
            padding:        '20px',
            backdropFilter: 'blur(4px)',
            overflowY:      'auto',
          }}
        >
          <div
            ref={formRef}
            style={{
              background:   '#fff',
              borderRadius: '16px',
              padding:      'clamp(28px, 5vw, 40px) clamp(22px, 4vw, 36px)',
              width:        '100%',
              maxWidth:     '480px',
              direction:    'rtl',
              fontFamily:   "'Cairo', sans-serif",
              position:     'relative',
              animation:    'fadeInUp 0.35s ease',
              maxHeight:    '90vh',
              overflowY:    'auto',
              boxSizing:    'border-box',
            }}
          >
            <button
              onClick={() => setShowModal(false)}
              style={{
                position:   'absolute',
                top:        '16px',
                left:       '16px',
                background: 'none',
                border:     'none',
                fontSize:   '22px',
                cursor:     'pointer',
                color:      '#888',
                lineHeight: 1,
                padding:    '4px 8px',
              }}
            >
              ✕
            </button>

            {/* Header (نفس EmaarContactForm) */}
            <div style={{ marginBottom: '24px' }}>
              <p style={{
                fontSize:      '11px',
                fontWeight:    '700',
                color:         '#c8a04a',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                margin:        '0 0 10px 0',
              }}>
                EMAAR GOLF FIELD
              </p>
              <h2 style={{
                fontSize:   'clamp(20px, 3vw, 26px)',
                fontWeight: '900',
                color:      '#1a1a1a',
                margin:     '0 0 8px 0',
                lineHeight: '1.2',
              }}>
                لمزيد من التفاصيل
              </h2>
              <p style={{ fontSize: '14px', color: '#888', margin: '0 0 4px 0' }}>
                سجل بياناتك وسنتواصل معك في أقرب وقت
              </p>
              <div style={{
                width:        '48px',
                height:       '3px',
                background:   'linear-gradient(to left, #c8a04a, #f0d080)',
                borderRadius: '2px',
                marginTop:    '14px',
              }} />
            </div>

            {/* Alert */}
            {alert.show && (
              <div style={{
                background:   alert.ok ? 'rgba(74,124,63,0.08)' : 'rgba(200,50,50,0.07)',
                border:       `1px solid ${alert.ok ? 'rgba(74,124,63,0.3)' : 'rgba(200,50,50,0.25)'}`,
                borderRadius: '10px',
                padding:      '11px 16px',
                marginBottom: '18px',
                fontSize:     '14px',
                fontWeight:   '600',
                color:        alert.ok ? '#2e5e26' : '#9b2020',
                display:      'flex',
                justifyContent: 'space-between',
                alignItems:   'center',
              }}>
                <span>{alert.message}</span>
                <button
                  onClick={() => setAlert((p) => ({ ...p, show: false }))}
                  style={{ background: 'none', border: 'none', cursor: 'pointer',
                    color: 'inherit', fontSize: '16px', lineHeight: 1, padding: '0 0 0 8px' }}
                >✕</button>
              </div>
            )}

            {/* Form */}
            <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

              {/* الاسم */}
              <div>
                <label style={labelStyle}>الاسم</label>
                <input
                  type="text"
                  placeholder="الاسم"
                  value={formData.name}
                  onChange={handleChange('name')}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  style={inputStyle}
                />
              </div>

              {/* رقم الهاتف */}
              <div>
                <label style={labelStyle}>
                  رقم الهاتف <span style={{ color: '#c8a04a' }}>*</span>
                </label>
                <div style={{ display: 'flex', gap: '8px', direction: 'ltr' }}>

                  {/* Select كود الدولة */}
                  <div style={{ position: 'relative', flexShrink: 0, width: '128px' }}>
                    <img
                      src={`https://flagcdn.com/w20/${selectedCountry.iso}.png`}
                      alt={selectedCountry.iso}
                      style={{
                        position:  'absolute',
                        left:      '10px',
                        top:       '50%',
                        transform: 'translateY(-50%)',
                        width:     '20px',
                        borderRadius: '2px',
                        pointerEvents: 'none',
                        zIndex: 1,
                      }}
                    />
                    <select
                      value={countryIso}
                      onChange={(e) => setCountryIso(e.target.value)}
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      style={{
                        ...inputStyle,
                        direction:        'ltr',
                        paddingLeft:      '38px',
                        paddingRight:     '26px',
                        appearance:       'none',
                        WebkitAppearance: 'none',
                        backgroundImage:  `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c8a04a' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                        backgroundRepeat:   'no-repeat',
                        backgroundPosition: 'right 10px center',
                        cursor:             'pointer',
                        fontWeight:         '600',
                        fontSize:           '13px',
                      }}
                    >
                      {countryCodes.map((c) => (
                        <option key={c.iso} value={c.iso}>
                          {c.dial} {c.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* رقم الهاتف */}
                  <input
                    type="tel"
                    placeholder="رقم الهاتف"
                    value={formData.phone}
                    onChange={handleChange('phone')}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{ ...inputStyle, direction: 'ltr', textAlign: 'right', flex: 1 }}
                  />
                </div>
              </div>

              {/* الإيميل */}
              <div>
                <label style={labelStyle}>الإيميل</label>
                <input
                  type="email"
                  placeholder="الإيميل"
                  value={formData.email}
                  onChange={handleChange('email')}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  style={{ ...inputStyle, direction: 'ltr', textAlign: 'right' }}
                />
              </div>

              {/* الغرض من الشراء */}
              <div>
                <label style={labelStyle}>الغرض من الشراء</label>
                <select
                  value={formData.question1_answer}
                  onChange={handleChange('question1_answer')}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  style={{
                    ...inputStyle,
                    appearance:      'none',
                    WebkitAppearance:'none',
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c8a04a' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                    backgroundRepeat:   'no-repeat',
                    backgroundPosition: 'left 14px center',
                    paddingLeft:        '36px',
                    cursor:             'pointer',
                  }}
                >
                  {purposeOptions.map((o) => (
                    <option key={o} value={o}>{o}</option>
                  ))}
                </select>
              </div>

              {/* عدد الغرف */}
              <div>
                <label style={labelStyle}>عدد الغرف</label>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  {roomOptions.map((room) => (
                    <label
                      key={room}
                      style={{
                        display:      'flex',
                        alignItems:   'center',
                        gap:          '6px',
                        cursor:       'pointer',
                        fontSize:     '13px',
                        fontWeight:   '600',
                        color:        formData.question2_answer === room ? '#c8a04a' : '#555',
                        padding:      '7px 14px',
                        borderRadius: '8px',
                        border:       `1.5px solid ${formData.question2_answer === room ? '#c8a04a' : '#e0d8cc'}`,
                        background:   formData.question2_answer === room ? 'rgba(200,160,74,0.08)' : '#fff',
                        transition:   'all 0.2s ease',
                      }}
                    >
                      <input
                        type="radio"
                        name="rooms"
                        value={room}
                        checked={formData.question2_answer === room}
                        onChange={handleChange('question2_answer')}
                        style={{ display: 'none' }}
                      />
                      {room}
                    </label>
                  ))}
                </div>
              </div>

              {/* زرار الإرسال */}
              <button
                type="submit"
                disabled={loading}
                style={{
                  width:        '100%',
                  padding:      '15px',
                  marginTop:    '6px',
                  background:   loading ? 'rgba(200,160,74,0.5)' : 'linear-gradient(135deg, #b8903a, #c8a04a, #e0b84a)',
                  color:        '#fff',
                  border:       'none',
                  borderRadius: '12px',
                  fontSize:     '16px',
                  fontWeight:   '700',
                  fontFamily:   "'Cairo', sans-serif",
                  cursor:       loading ? 'not-allowed' : 'pointer',
                  boxShadow:    '0 6px 20px rgba(200,160,74,0.35)',
                  transition:   'all 0.25s ease',
                  letterSpacing:'0.5px',
                }}
                onMouseEnter={(e) => { if (!loading) e.target.style.boxShadow = '0 10px 28px rgba(200,160,74,0.5)'; }}
                onMouseLeave={(e) => { e.target.style.boxShadow = '0 6px 20px rgba(200,160,74,0.35)'; }}
              >
                {loading ? 'جاري الإرسال...' : 'إرسال'}
              </button>
            </form>
          </div>
        </div>
      )}

      <style>{`
        @keyframes scrollDot {
          0%, 100% { transform: translateX(-50%) translateY(0); opacity: 1; }
          50%       { transform: translateX(-50%) translateY(12px); opacity: 0.3; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};
